module.exports = __webpack_public_path__ + "img/34.3.TP.c520f355.png";